import * as React from 'react'
import {
  List,
  DatagridConfigurable,
  TextField,
  DateField,
  FilterButton,
  TopToolbar,
  SelectColumnsButton,
  TextInput,
  EditButton,
  ShowButton,
  CreateButton,
  ReferenceField,
  ReferenceInput,
  SelectInput,
  NumberField
} from 'react-admin'
import { Box } from '@mui/material'

const filters = [
  <ReferenceInput source="providerGroupId" reference="provider-groups" label="Provider Group" alwaysOn>
    <SelectInput optionText="name" emptyText="All Provider Groups" resettable sx={{ width: '250px' }} />
  </ReferenceInput>,
  <SelectInput source="billingPeriod" label="Billing Period" emptyText="All Billing Periods" choices={[
    { id: 'monthly', name: 'Monthly' },
    { id: 'quarterly', name: 'Quarterly' },
    { id: 'yearly', name: 'Yearly' },
  ]} resettable alwaysOn sx={{ width: '250px' }} />
]

const ListActions = () => (
  <TopToolbar>
    <FilterButton />
    <SelectColumnsButton />
    <CreateButton label="New Contract" />
  </TopToolbar>
)

const ProviderContractList = (props) => {
  return (
    <Box>
      <List
        {...props}
        filters={filters}
        actions={<ListActions />}
        sort={{ field: 'startDate', order: 'DESC' }}
      >
        <DatagridConfigurable bulkActionButtons={false} rowClick="show">
          <ReferenceField link="show" source="providerGroupId" reference="provider-groups" label="Provider Group">
            <TextField source="name" />
          </ReferenceField>
          <DateField source="startDate" label="Start Date" sortable={false} />
          <TextField source="billingPeriod" label="Billing Period" sx={{ textTransform: 'capitalize' }} />
          <NumberField source="customerPrice" label="Customer Price" options={{ style: 'currency', currency: 'USD' }} />
          <NumberField source="daysToConvert" label="Days to Convert" />
          <DateField source="createdAt" label="Created At" showTime sortable={false} />
          <EditButton label="Edit" />
        </DatagridConfigurable>
      </List>
    </Box>
  )
}

export default ProviderContractList
